import React, {useContext} from 'react'
import s from './PlayingField.module.scss'
import Roulette from './Roulette/Roulette'
import Odds from "./Odds/Odds";
import InitialStateContext from "../../../context/InitialStateContext";
import {Result, RiskType, SegmentColorType, SegmentCountType} from "../../../types/Game";

const PlayingField: React.FC<IProps> = ({ riskType, segmentsCount, gameResult, isGame, isDrizzlePartner }) => {
    const [initialState] = useContext(InitialStateContext)

    const segments = initialState.oddsInfo[riskType][segmentsCount]
    const segmentsArray = Object.entries(segments) as Array<[SegmentColorType, number]>

    return (
        <div className={s.wrapper}>
            <Roulette
                gameResult={gameResult}
                selectedRiskType={riskType}
                selectedSegmentsCount={segmentsCount}
                isGame={isGame}
                isDrizzlePartner={isDrizzlePartner}
            />
            <Odds
                segments={segmentsArray}
                isDrizzlePartner={isDrizzlePartner}
            />
        </div>
    )
}

export default PlayingField

interface IProps {
    gameResult: Result | null
    riskType: RiskType
    segmentsCount: SegmentCountType
    isGame: boolean
    isDrizzlePartner: boolean
}